//Maps key names to their corresponding key codes
export function keyToKeyCode(key) {
    const map = {
        ArrowUp: 38,
        ArrowDown: 40,
        ArrowLeft: 37,
        ArrowRight: 39,
        Enter: 13,
        Backspace: 8,
    };
    return map[key] || 0;
}

// Creates a synthetic keyboard event
export function createKeyboardEvent(key) {
    return new KeyboardEvent("keydown", {
        key: key,
        code: key,
        keyCode: keyToKeyCode(key),
        which: keyToKeyCode(key),
        bubbles: true,
    });
}
